import { AnyAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../';
import { N2NFieldsType } from '../../layouts/devops-screen/types';

type N2NFieldProgressActionType = {
  readonly type: string;
  readonly payload?: {
    readonly fieldName: 'email' | 'password' | 'fullName' | 'sitenameNew';
    readonly isPopulated: boolean;
  };
};

// Actions
const INPUT_POPULATED_EMAIL = 'n2n-field-progress/INPUT_POPULATED_EMAIL';
const INPUT_POPULATED_PASSWORD = 'n2n-field-progress/INPUT_POPULATED_PASSWORD';
const INPUT_POPULATED_FULL_NAME =
  'n2n-field-progress/INPUT_POPULATED_FULL_NAME';

// Initial State
const initialState: N2NFieldsType = {
  email: false,
  password: false,
  fullName: false,
  sitenameNew: false
};

// Reducer
export const n2nFieldProgressReducer = (
  state = initialState,
  action: N2NFieldProgressActionType
): N2NFieldsType => {
  switch (action.type) {
    case INPUT_POPULATED_EMAIL:
    case INPUT_POPULATED_PASSWORD:
    case INPUT_POPULATED_FULL_NAME:
      return Object.assign({}, state, {
        [action?.payload?.fieldName as string]: action?.payload?.isPopulated
      });
    default:
      return state;
  }
};

// Thunks
export function updateN2NFieldProgressEmail(payload: boolean) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldProgress: { email }
    } = getState();
    if (email !== payload) {
      dispatch({
        type: INPUT_POPULATED_EMAIL,
        payload: {
          fieldName: 'email',
          isPopulated: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NFieldProgressPassword(payload: boolean) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldProgress: { password }
    } = getState();
    if (password !== payload) {
      dispatch({
        type: INPUT_POPULATED_PASSWORD,
        payload: {
          fieldName: 'password',
          isPopulated: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NFieldProgressFullName(payload: boolean) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldProgress: { fullName }
    } = getState();
    if (fullName !== payload) {
      dispatch({
        type: INPUT_POPULATED_FULL_NAME,
        payload: {
          fieldName: 'fullName',
          isPopulated: payload
        }
      });
    }
  }) as unknown as AnyAction;
}
